import Image from 'next/legacy/image';
import { APPSTORE_APP_LINK, GOOGLE_PLAY_APP_LINK } from 'consts';
import { NextLink } from 'components/NextLink';

import styles from './DownloadAppBanner.module.scss';

export const DownloadAppBanner = () => {
  return (
    <div className={styles.downloadBannerContainer}>
      <div className={styles.downloadBannerLeftPart}>
        <h2 className={styles.downloadBannerHeader}>
          Download the App <br />
          on iPhone and Android.
        </h2>
        <p className={styles.downloadBannerDescription}>
          Make your orders and sales faster with our crossplatform application
        </p>
        <div className={styles.downloadBannerIcons}>
          <NextLink href={APPSTORE_APP_LINK} newTab={true}>
            <Image
              alt="App Store"
              src="/App_Store_Badge.svg"
              width={144}
              height={48}
              layout="fixed"
              objectFit="cover"
            />
          </NextLink>
          <NextLink href={GOOGLE_PLAY_APP_LINK} newTab={true}>
            <Image
              alt="Google Pay"
              src="/Google_Play_Store.svg"
              width={162}
              height={48}
              layout="fixed"
              objectFit="cover"
            />
          </NextLink>
        </div>
      </div>
      <div className={styles.downloadBannerRightPart}>
        <Image alt="App Design" src="/phone.jpg" width={546} height={546} layout="responsive" objectFit="cover" />
      </div>
    </div>
  );
};
